<template>
  <memlist-card>
    <h5 class="mb-4 mt-4 ">{{ task.name }}</h5>

    <p class="mb-8">{{ task.descr }}</p>

    <h6 class="mb-4 mt-5">Inlämningsperiod</h6>

    <table class="table table-head-custom table-vertical-center table-head-bg table-borderless">
      <thead>
        <tr class="text-left">
          <th style="min-width: 110px">{{ $t('TODO.START_DATE') }} </th>
          <th style="min-width: 110px">{{ $t('TODO.END_DATE') }} </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <span class="text-dark-75  d-block font-size-lg">{{ todo.from_datetime }}</span>
          </td>
          <td>
            <span class="text-dark-75 d-block font-size-lg">{{ todo.to_datetime }}</span>
          </td>
        </tr>
      </tbody>
    </table>

    <memlist-static-table
      :items="todo.tasks"
      :fields="fields"
    >
    </memlist-static-table>
  </memlist-card>
</template>

<script>
export default {
  name: "IntroPage",
  props: ['todo', 'task'],
  data() {
    return {
      fields: [
        {
          key: 'name',
          label: 'Åtgärd',
          sortable: false,
          mobile: true,
          tdClass: 'td-overflow',
          thClass: 'td-overflow'
        },
      ],
    }
  }
}
</script>

<style scoped></style>
